import React, { useState, useEffect, useLayoutEffect } from 'react'
import '../Managing/Managing.css'
import './Reading.css'
import ReadControl from './ReadControl'
import {Parts} from './Parts'

import {PartControl} from './Parts'

import {meSplitter} from '../Shared/meLayout'
import Activities from '../Shared/Activities'

const Reading = ({layout, search, Etat}) => {
    const entity='Reading'
    const activity=1
        const [page, Page] = useState(1)
        const [part, Part] = useState({id:1, page:1, pages:21})
        const [note, Note] = useState(0)
        const data = {parts:30, pages:604, root:"https://moshaf.akademy.ma/safahaat/"}
        const [reported, Reported] = useState(6)
        const [path, Path] = useState(data.root+'warsh/')

        const splitter = new meSplitter(`${entity}Side`,`${entity}Container`,layout)
        useLayoutEffect (()=>{  
            //alert(layout)
            splitter.selectorAll() 
        })

        const onPrev = () => {
            Page(page>0 ? page-1 : data.pages)
        }
    
        const onNext =() => {
            Page(page<data.pages ? page+1 : 0)
        }

        const onPart = (selected) => {
            //console.log('Reading.onPart', selected); alert(selected.id)
            if(selected.id>0 && selected.id<=data.parts){
                Page(selected.page)
                Part(selected)
            }
        }

        const onPage = (selected) => {
            //  console.log('Reading.onPage', selected); alert(selected)
            if(selected>=0 && selected<=data.pages)
                Page(selected)
        }

        const onNote = (id) => {
            Note(id)
        }

return (

data.parts>0 && page>0 ?

    layout ?
    <div className="Sides" id={`${entity}Container`} 
        onMouseDown={(e)=>{splitter.mouseDown(e)}} 
        onMouseMove={(e)=>{splitter.mouseMove(e)}} 
        onMouseUp={(e)=>{splitter.mouseUp(e)}}
        >
        <div className="side vside" id={`${entity}SideActivities`} style={{width: '30%'}}>
            <Activities activity={activity} element={page} onElement={onNote} reported={reported} search={search} />
        </div>
        <div className="side vside" id={`${entity}SideReadControl`} style={{width: '40%', overflow: 'hidden'}}>
            <ReadControl path={data.root} onPath={Path} part={part} page={page} onNext={onNext} onPrev={onPrev} onPart={onPart} onPage={onPage} Etat={Etat} />
        </div>
        <div className="side vside" id={`${entity}SideParts`} style={{width: '30%'}}>
            <Parts path={path} part={part} page={page} onPart={onPart} onPage={onPage} />
        </div>
    </div>
    :
    <div className="Sides" id={`${entity}Container`} 
    onMouseDown={(e)=>{splitter.mouseDown(e)}} 
    onMouseMove={(e)=>{splitter.mouseMove(e)}} 
    onMouseUp={(e)=>{splitter.mouseUp(e)}}
    >

        <ReadControl path={data.root} onPath={Path} part={part} page={page} onNext={onNext} onPrev={onPrev} onPart={onPart} onPage={onPage} Etat={Etat} />
    </div>
: 
<h5>Not Connected</h5> 
     )
}

export default Reading
